import { make } from 'vuex-pathify';
import { state as fpgConfiguration } from '@/store/fpgConfiguration';

const mutations = {
  ...make.mutations(fpgConfiguration),
};

export { mutations };
